import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {StatisticModuleName, UserServiceModuleName} from "../utils/names/optionalModuleNames";
import {NavigationItem} from "../main/model/navigationItem";
import 'chart.js';
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";
import {getTabName} from "modules/utils/TabNameUtils";

export const StatisticModule = new RestrictedRouteModuleConfiguration(
    UserGranredAuthorityName.STATISTICS,
    [
        AngularJsMaterialModuleName,
        StatisticModuleName,
        UserServiceModuleName
    ],
    [
        ['/statistics', {
            template: require('./route/statistics.html'),
            controller: 'statisticsController',
            reloadOnSearch: false
        }]
    ],
    [
        new NavigationItem({
            title: "Statistics",
            href: "#!statistics",
            activeFunction: (routeName) => {
                return routeName.indexOf("statistics") !== -1;
            }
        })
    ],
    [StatisticModuleName],
    [UserGranredAuthorityName.STATISTICS],
    getTabName() + '| Statistics'
);

export default StatisticModule;